import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import pt from './locales/pt-br.json';

i18n.use(initReactI18next).init({
  resources: {
    pt: { ...pt },
  },
  lng: 'pt',
});
